// eslint-disable-next-line no-unused-vars
import axios from 'axios'
import moment from 'moment';

import { endpoints } from 'Core/defaultValues';

import packageJson from '../../../package.json';

export const HasPermission = (user, code, action) => {
	
	let permission = false
	try {

		let oldPermits = localStorage.getItem("permissions") || [];
		try {
			oldPermits = JSON.parse(oldPermits);
		} catch (error) {}
		
		let currentPermits = user?.permissions || oldPermits || [];
		
		if (code) {
			let validateCode = currentPermits.some((permission) => permission.code === code);
			permission = validateCode;
			if (permission && action) {
				let actionValidation = currentPermits.find((permission) => permission.code === code);
				permission = actionValidation[action] || false
			}
		}
		return permission
	} catch (error) {
		return false
	}
}

let lastRevision;

export const GerVersionFromServer = (callback) => {
	if (!lastRevision || moment() >= lastRevision) {
		lastRevision = moment().add(5, 'second')
		try {
			const buildVersionUrl = () => {
				const cacheBusterParam = `date=${Date.now()}`;
				const appendCacheBuster = (url) => `${url}${url.includes('?') ? '&' : '?'}${cacheBusterParam}`;
				const envUrl = endpoints.VERSION_PUBLISH;

				if (!envUrl) {
					return appendCacheBuster('/version.json');
				}

				try {
					const resolvedUrl = new URL(envUrl, window.location.origin);
					const isCrossOrigin = resolvedUrl.origin !== window.location.origin;

					if (isCrossOrigin && window.location.hostname === 'localhost') {
						// Use the bundled version.json during local development to avoid CORS issues.
						return appendCacheBuster('/version.json');
					}

					return appendCacheBuster(resolvedUrl.toString());
				} catch (error) {
					return appendCacheBuster(envUrl);
				}
			};

			const versionUrl = buildVersionUrl();
			axios.get(versionUrl).then(version => {
				if (version.status === 200 && version.data && version.data.Version) {
					localStorage.setItem("currentVersion", version.data.Version)
					if (callback)
						callback()
				}
			}).catch(() => { });

		} catch (error) { }
	}
}

export const ValidateVersion = (type) => {

	let currentString = packageJson.version
	let latestString = localStorage.getItem("currentVersion")
	let currentNumber = 0
	let latestNumber = 0

	if (currentString)
		currentNumber = parseInt(currentString.replace(".", "").replace(".", ""))

	if (latestString)
		latestNumber = parseInt(latestString.replace(".", "").replace(".", ""))

	if (currentString && latestString && currentNumber < latestNumber) {
		window.location.reload();
	}

	return (
		<></>
	)
}
